import Mock from "mockjs";
import { getCharts, getViews } from "./dashboard";
import getChartData from "./chart-data";

// 配置Ajax请求延时，可用来测试网络延迟大时项目中一些效果
Mock.setup({
  timeout: 1000
});

Mock.mock(/\/getViews/, getViews);
Mock.mock(/\/getCharts/, getCharts);
// if (process.env.NODE_ENV !== "production")
//   Mock.mock(/chart\/getChartData/, getChartData);
export default Mock;



// WEBPACK FOOTER //
// ./src/mock/index.js